var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSausage = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 35C10.5716 35 8.33325 32.7617 8.33325 30C8.33325 27.2567 10.5399 25.0317 13.2749 25C14.2799 24.9683 22.6983 24.3467 25.0983 12.3533C25.6383 9.64501 28.2682 7.88501 30.9799 8.43001C33.6882 8.97001 35.4449 11.605 34.9032 14.3117C31.6316 30.6767 19.3633 35 13.3333 35Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M3.67844 30C2.93677 30 2.56344 30.8983 3.08844 31.4233C4.31344 32.6467 5.0001 34.305 5.0001 36.035V36.3217C5.0001 37.0633 5.89844 37.4367 6.42344 36.9117L9.79844 33.5367C8.89344 32.6317 8.33344 31.3817 8.33344 30H3.67844Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M36.8267 6.42331C37.3517 5.89831 36.98 4.99997 36.2383 4.99997H35.6067C34.28 4.99997 33.0083 4.47331 32.0717 3.53497L31.4233 2.88664C30.8983 2.36164 30 2.73331 30 3.47664V8.33497C30.3233 8.33497 30.65 8.36497 30.98 8.43164C31.9083 8.61664 32.7117 9.06164 33.3633 9.65664L33.5367 9.71497L36.8267 6.42331Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSausage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sausage.87d567f3.svg";
export { ForwardRef as ReactComponent };